import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { mergeStyles } from '../../utils/StyleUtils';
import withMemo from '../../decorators/withMemo';
import ActionButton from '../ActionButton';
import styles from './styles';
var useStyles = createUseStyles(styles);
var PageActions = function PageActions(props) {
  var classesProp = props.classes,
    className = props.className,
    actions = props.actions;
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  if (!actions) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(ActionButton, _extends({
      key: "action-".concat(index)
    }, action));
  })));
};
PageActions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string),
  actions: PropTypes.arrayOf(PropTypes.shape(ActionButton.propTypes))
};
PageActions.defaultProps = {
  className: null,
  classes: {},
  actions: null
};
export default withMemo()(PageActions);